import { inject, Injectable } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { VonMessageService } from '@von-development-studio/primeng-helper';

interface AppMessageType {
  message: string;
  summary?: string;
  data?: any;
  sticky?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class AppMessageService {
  private readonly messageService = inject(VonMessageService);
  private readonly translatePipe = inject(TranslatePipe);

  readonly closeAll = () => {
    this.messageService.clearAll();
  };

  readonly success = (data: AppMessageType) => {
    this.callService(data, this.messageService.success);
  };

  readonly info = (data: AppMessageType) => {
    this.callService(data, this.messageService.info);
  };

  readonly warning = (data: AppMessageType) => {
    this.callService(data, this.messageService.warning);
  };

  readonly error = (data: AppMessageType) => {
    this.callService(data, this.messageService.error);
  };

  private readonly callService = ({ message, summary, sticky, data }: AppMessageType, method: any) => {
    method(this.translatePipe.transform(message, data), {
      summary: this.translatePipe.transform(summary, data),
      sticky,
      data,
    });
  };

  /**
   * @deprecated User method method success.
   */
  readonly addSuccess = (text: string, data?: any, sticky: boolean = false) => {
    const { detail: message, summary } = this.extractMessage(text);
    this.success({ message, summary, sticky, data });
  };

  /**
   * @deprecated User method method success.
   */
  readonly addInfo = (text: string, data?: any, sticky: boolean = false) => {
    const { detail: message, summary } = this.extractMessage(text);
    this.info({ message, summary, sticky, data });
  };

  /**
   * @deprecated User method method success.
   */
  readonly addWarning = (text: string, data?: any, sticky: boolean = false) => {
    const { detail: message, summary } = this.extractMessage(text);
    this.warning({ message, summary, sticky, data });
  };

  /**
   * @deprecated User method method success.
   */
  readonly addError = (text: string, data?: any, sticky: boolean = false) => {
    const { detail: message, summary } = this.extractMessage(text);
    this.error({ message, summary, sticky, data });
  };

  /**
   * @deprecated User method method success.
   */
  private readonly extractMessage = (message: string): { detail: string; summary?: string } => {
    const messageSplit = message?.split('#') ?? '';
    if (messageSplit.length > 1) {
      return {
        detail: messageSplit[1],
        summary: messageSplit[0],
      };
    }
    return {
      detail: messageSplit[0],
    };
  };
}
